import palette from './palette';

export default {
  fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
  h1: {
    color: palette.text.primary,
    fontWeight: 500,
    fontSize: '45px',
    lineHeight: '40px',
    fontFamily: 'Trade Gothic',
    textTransform: 'uppercase',
  },
  h2: {
    color: palette.text.primary,
    fontWeight: 500,
    fontSize: '29px',
    lineHeight: '32px',
    fontFamily: 'Trade Gothic',
  },
  h3: {
    color: palette.text.primary,
    fontWeight: 500,
    fontSize: '24px',
    lineHeight: '28px',
    fontFamily: 'Trade Gothic',
    textTransform: 'uppercase',
  },
  h4: {
    color: palette.text.primary,
    fontWeight: 300,
    fontSize: '20px',
    lineHeight: '24px',
  },
  h5: {
    color: palette.text.primary,
    fontWeight: 500,
    fontSize: '16px',
    lineHeight: '20px',
  },
  h6: {
    color: palette.text.primary,
    fontWeight: 500,
    fontSize: '14px',
    lineHeight: '20px',
  },
  subtitle1: {
    color: palette.text.primary,
    fontSize: '16px',
    lineHeight: '25px',
  },
  subtitle2: {
    color: palette.text.secondary,
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '21px',
  },
  body1: {
    color: palette.text.primary,
    fontSize: '14px',
    fontWight: 300,
    lineHeight: '21px',
  },
  body2: {
    color: palette.text.secondary,
    fontSize: '12px',
    fontWight: 300,
    lineHeight: '18px',
  },
  button: {
    color: palette.text.primary,
    fontSize: '14px',
    fontFamily: 'Trade Gothic',
  },
  caption: {
    color: palette.text.secondary,
    fontSize: '15px',
    letterSpacing: '0.33px',
    lineHeight: '13px',
  },
  overline: {
    color: palette.text.secondary,
    fontSize: '11px',
    fontWeight: 300,
    letterSpacing: '0.33px',
    lineHeight: '13px',
    textTransform: 'uppercase',
  },
};
